import { render, staticRenderFns } from "./sum-radio-group.vue?vue&type=template&id=3fae78be"
import script from "./sum-radio-group.ts?vue&type=script&lang=ts&external"
export * from "./sum-radio-group.ts?vue&type=script&lang=ts&external"
import style0 from "./sum-radio-group.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports